document.addEventListener("DOMContentLoaded",(event) => {
  // document.querySelector('.header-center button').addEventListener('click',function(e){
  //   e.preventDefault();
  //   document.querySelector('body').classList.add('open-menu');
  //   document.querySelector('.snippet-menu-drawer').classList.add('fade-in');
  // })
  // document.querySelector('.menu-drawer-close').addEventListener('click',function(e){
  //   e.preventDefault();
  //   document.querySelector('body').classList.remove('open-menu');
  //    document.querySelector('.snippet-menu-drawer').classList.remove('fade-in');
  // })
  // ------------fade in animation 
  
    const menuDrawer = document.querySelector('.snippet-menu-drawer');
    const body = document.querySelector('body');
    
    // Open menu
    document.querySelector('.header-center button').addEventListener('click', function(e) {
      e.preventDefault();
      body.classList.add('open-menu');
      menuDrawer.classList.remove('fade-out');
      menuDrawer.classList.add('fade-in');
    });
    
    // Close menu with fade-out
    document.querySelector('.menu-drawer-close').addEventListener('click', function(e) {
      e.preventDefault();
      menuDrawer.classList.remove('fade-in');
      menuDrawer.classList.add('fade-out');
    
      // Wait for animation to end before fully hiding
      menuDrawer.addEventListener('animationend', function handleFadeOut() {
        body.classList.remove('open-menu');
        menuDrawer.classList.remove('fade-out');
        menuDrawer.removeEventListener('animationend', handleFadeOut);
      });
    });

  
  // if(document.querySelector('.list-menu')){
  //   document.querySelectorAll('.list-menu > .mega-list').forEach(function(navList){
  //     navList.addEventListener('click', function(e){
  //       e.preventDefault();
  //       console.log('menu click');
  //       document.querySelector('body').classList.toggle('open-menu');
  //     });
  //   });
  // }
  if (document.querySelector('.list-menu')) {
  document.querySelectorAll('.list-menu > .mega-list').forEach(function (navList) {
    navList.addEventListener('click', function (e) {
      e.preventDefault();
      console.log('menu click');
      document.querySelector('body').classList.toggle('open-menu');
    });
  });

  // Close menu when clicking outside .mega-nav and .mega-img
    if (window.innerWidth > 991) {
       document.addEventListener('click', function (event) {
    const isInsideMegaNav = event.target.closest('.mega-nav');
    const isInsideMegaImg = event.target.closest('.mega-img');
    const isInsideMenuTrigger = event.target.closest('.mega-list'); // prevents instant close

    if (!isInsideMegaNav && !isInsideMegaImg && !isInsideMenuTrigger) {
      document.body.classList.remove('open-menu');
    }
  });
    }
 
}



  //   if (document.querySelector('.list-menu') || document.querySelector('.snippet-header-nav')) {
  //     document.querySelectorAll('.list-menu > .mega-list, .snippet-header-nav').forEach(function(element) {
  //         element.addEventListener('mouseenter', function() {
  //             document.body.classList.add('open-menu');
  //         });
  //         element.addEventListener('mouseleave', function() {
  //             document.body.classList.remove('open-menu');
  //         });
  //     });
  // }


  document.querySelectorAll('.searchlist').forEach(function(searchButton){
    searchButton.addEventListener('click',function(e){
      e.preventDefault();
      document.querySelector('body').classList.toggle('open-search');
      document.querySelector('body').classList.remove('open-drawer','open-menu','open-sort','open-filter','open-wishlist');
      setTimeout(() => {
        // document.querySelector(".searchbox #Search").focus();
      },400);
    });
  });
  document.querySelectorAll('.search-close-btn,.searchbox_overly').forEach(function(searchClose){
    searchClose.addEventListener('click',function(e){
      e.preventDefault();
      document.querySelector('body').classList.remove('open-search');
    });
  });
});

if(document.querySelector(".mega-img-btn")){
  const addButton = document.querySelector(".mega-img-btn");
  const variantElement = document.querySelector(".mega-pro");
  const variantSelect = variantElement ? variantElement.getAttribute("var-id") : null;
    addButton.addEventListener("click", function () {
      console.log("selectedVariantId:", variantSelect);
  
      const data = new FormData();
      data.append("id", variantSelect);
      data.append("quantity", 1);
  
      fetch("/cart/add.js", {
        method: "POST",
        body: data,
      })
        .then(response => response.json())
        .then(() => {
           load_cart();
          document.body.classList.add("open-drawer");
        })
        .catch(error => {
          console.error("Error adding to cart:", error);
        });
    });
}
